import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatListOption } from '@angular/material/list';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { Clipboard } from '@angular/cdk/clipboard';

import { AccountTypeEnum, CareerProcessTypeEnum, ClaroRoles, OrgDataUpdateComparison, OrgDataUpdateRun, ResellerTokesStatusData, ResellerTypeEnum, UserCreatedOrgData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';

@Component({
  selector: 'app-admin-actions',
  templateUrl: './admin-actions.component.html',
  styleUrls: ['./admin-actions.component.scss']
})
export class AdminActionsComponent extends BaseComponent implements OnInit {
  presentReallocateTokensPart : boolean = false;
  reallocateAccessTokens_resellerMail: string = "";
  reallocateAccessTokensList: string = "";
  changeParent_SubordinatesList: string = "";
  changeOrg_usersList : string = "";
  changeParent_parentMail: string = "";
  changeOrg_orgId: string = "";
  tokensAmount : number = 0;
  res_reallocatedTokensList : string []= [];
  res_allocatedTokensToGroupList : string[] = [];
  reallocateTokenByAmountFailed :boolean = false;
  reallocateTokensErrorMessage : string = "";
  userMgmt_changeParentFailed: boolean = false;
  userMgmt_changeOrgFailed: boolean = false;
  userMgmt_changeParentSucceeded : boolean = false;
  userMgmt_changeOrgSucceeded : boolean = false;
  adminActionMessage : string = "";
  isWaitingForReport: boolean = false;
  isWaitingForReallocation: boolean = false;
  isWaitingForParentChange: boolean = false;
  isWaitingForOrgChange: boolean = false;
  questionsVideoFolder = 'assets/media/questions/';
  getOrgs_resellerOrgsList: UserCreatedOrgData[] = [];
  allocatedTokensCopied = false;
  changeParent_missingUsers : string[] = [];
  changeOrg_missingUsers : string[] = [];
  getOrgs_getOrgsDone : boolean = false;
  getResellerOrgs_resellerMail : string = "";
  isWaitingForResellerOrgsList : boolean = false;
  updateToReseller_resellerMail : string = "";
  accountTypeEnuInstance = AccountTypeEnum;
  careerProcessTypeEnumInstance = CareerProcessTypeEnum;
  selectedAccountTypeForTokenAllocation : AccountTypeEnum = AccountTypeEnum.UNKNOWN;
  selectedCareerProcessTypeForTokenAllocation : CareerProcessTypeEnum = CareerProcessTypeEnum.NONE;
  setOrgExpiration_expirationDate : Date;
  setOrgExpiration_orgId : string;
  getLastOrgDataUpdateReport_orgId : string = "";
  orgDataUpdatePreview?: OrgDataUpdateRun;
  orgDataUpdateSelectedRun?: OrgDataUpdateRun;
  orgDataUpdateRuns: OrgDataUpdateRun[] = [];
  orgDataUpdateCompareFromRunId: string = "";
  orgDataUpdateCompareToRunId: string = "";
  orgDataUpdateComparison?: OrgDataUpdateComparison;
  isWaitingForOrgDataUpdate: boolean = false;
  orgDataUpdateErrorMessage: string = "";
  orgDataUpdateSuccessMessage: string = "";
  resetPassword_userMail: string = "";
  resetPassword_newPassword: string = "";
  resetPassword_showPassword: boolean = false;
  isWaitingForPasswordReset: boolean = false;
  resetPassword_successMessage: string = "";
  resetPassword_errorMessage: string = "";

  constructor(private userDataService : AbstractPersonalUserDataService,
              private translate: TranslateService,
              private clipboard: Clipboard) {
    super();
   }

  ngOnInit(): void {
    super.ngOnInit();

    this.verifyResellerData();
  }

  verifyResellerData(): void{
    this.userDataService.getSelfResellerData().subscribe(resellerDetails => {
      if (resellerDetails && resellerDetails.resellerType == ResellerTypeEnum.MASTER_RESELLER){
        // this is a master reseller, we need to allow additional actions
        this.presentReallocateTokensPart = true;
      }
      else{
        this.presentReallocateTokensPart = false;
      }
    });
  }

  //reallocateAccessTokenByAmount
  reallocateTokensByAmount(): void{
    if (!(this.tokensAmount > 0) || this.reallocateAccessTokens_resellerMail=="" || this.selectedAccountTypeForTokenAllocation == AccountTypeEnum.UNKNOWN){
      this.reallocateTokenByAmountFailed = true;
      this.reallocateTokensErrorMessage = this.translate.instant('adminActions.missingDetails');
      return;
    }

    this.reallocateTokenByAmountFailed = false;
    this.reallocateTokensErrorMessage = "";
    this.isWaitingForReallocation = true;

    this.userDataService.reallocateAccessTokenByAmount( this.reallocateAccessTokens_resellerMail, this.tokensAmount, 
                                                        this.selectedAccountTypeForTokenAllocation, this.selectedCareerProcessTypeForTokenAllocation
                                                      ).subscribe(allocatedTokens => {
      this.res_reallocatedTokensList = allocatedTokens.map(token => token.tokenBody);
      this.isWaitingForReallocation = false;
    }, error => {
      if (error.status == 400){
          this.reallocateTokensErrorMessage = this.translate.instant('adminActions.reallocateTokensByAmountFailed')
      }
      this.reallocateTokenByAmountFailed = true;
      this.isWaitingForReallocation = false;
  });
  }
  
  userManagement_changeParent(): void{
    if (this.changeParent_parentMail == "" || this.changeParent_SubordinatesList==""){
      return;
    }

    this.userMgmt_changeParentFailed = false;
    this.userMgmt_changeParentSucceeded = false;
    this.adminActionMessage = "";
    this.isWaitingForParentChange = true;
    this.changeParent_missingUsers = [];

    this.userDataService.adminChangeParentToUsers(this.changeParent_parentMail, this.changeParent_SubordinatesList).subscribe(missingUsers => {
      if (missingUsers.length > 0){
        this.changeParent_missingUsers = missingUsers;
      }
      else{
        this.userMgmt_changeParentSucceeded = true;
      }

      this.isWaitingForParentChange = false;
    },error => {
          this.adminActionMessage = this.translate.instant('adminActions.adminActionFailed')
      });
  }

  userManagement_changeOrg(): void{
    if (this.changeOrg_orgId == "" || this.changeOrg_usersList==""){
      return;
    }

    this.userMgmt_changeOrgFailed = false;
    this.userMgmt_changeOrgSucceeded = false;
    this.adminActionMessage = "";
    this.isWaitingForOrgChange = true;
    this.changeOrg_missingUsers = [];


    this.userDataService.adminChangeOrgToUsers(this.changeOrg_orgId, this.changeOrg_usersList).subscribe(missingUsers => {
      if (missingUsers.length > 0){
        this.userMgmt_changeOrgFailed = true;
        this.changeOrg_missingUsers = missingUsers;
      }
      else{
        this.userMgmt_changeOrgSucceeded = true;
      }

      this.isWaitingForOrgChange = false;
    },error => {
      this.adminActionMessage = this.translate.instant('adminActions.adminActionFailed')
  });
  }

  copyAllocatedTokensToCLipboard() : void{
    let tokensListStr : string = JSON.stringify(this.res_allocatedTokensToGroupList);

    // remove '[' and ']' from the string
    tokensListStr = tokensListStr.substring(1, tokensListStr.length - 1)
    this.clipboard.copy(tokensListStr);

    this.allocatedTokensCopied = true;
  }

  userManagement_getResellerOrgs() : void{
    this.getOrgs_getOrgsDone = false;
    this.getOrgs_resellerOrgsList = [];
    this.isWaitingForResellerOrgsList = true;

    this.userDataService.getAllUserCreatedOrgs(this.getResellerOrgs_resellerMail).subscribe(userOrgs => {
        this.getOrgs_resellerOrgsList = userOrgs;
        this.isWaitingForResellerOrgsList = false;
        this.getOrgs_getOrgsDone = true;
    });
  }

  userManagement_updateUserToReseller() : void{
    this.adminActionMessage = "";
    this.personalUserDataServiceForBaseClass.adminConvertUserToReseller(this.updateToReseller_resellerMail).subscribe(res=>{
      this.adminActionMessage = this.translate.instant('adminActions.convertUserToResellerSucceeded');
    }, error => {
      this.adminActionMessage = this.translate.instant('adminActions.convertUserToResellerError');
    });
  }  

  orgManagement_setExpirationDate(): void{
    this.adminActionMessage = "";
    this.userDataService.adminSetExpirationDateToOrg(this.setOrgExpiration_orgId, this.setOrgExpiration_expirationDate).subscribe(res=>{
      this.adminActionMessage = this.translate.instant('adminActions.orgManagement_setExpirationDateSucceeded');
    }, error => {
      this.adminActionMessage = this.translate.instant('adminActions.orgManagement_setExpirationDateError');
    });

  }

  getLastOrgDataUpdateReport(): void{
    if (this.getLastOrgDataUpdateReport_orgId == ""){
      return;
    }
    this.userDataService.adminGetLastOrgDataUpdateReport(this.getLastOrgDataUpdateReport_orgId).subscribe(res=>{
      this.downloadTextFile(`org_data_update_report_${this.getLastOrgDataUpdateReport_orgId}.txt`, res.content);    
    });
  }

  previewOrgDataUpdate(): void {
    if (!this.getLastOrgDataUpdateReport_orgId) {
      return;
    }
    this.clearOrgDataUpdateMessages();
    this.isWaitingForOrgDataUpdate = true;
    this.userDataService.adminPreviewOrgDataUpdate(this.getLastOrgDataUpdateReport_orgId).subscribe({
      next: preview => {
        this.orgDataUpdatePreview = preview;
        this.orgDataUpdateSuccessMessage = this.translate.instant('adminActions.orgDataUpdatePreviewReady');
        this.isWaitingForOrgDataUpdate = false;
        this.loadOrgDataUpdateRuns();
      },
      error: (error: HttpErrorResponse) => this.handleOrgDataUpdateError(error)
    });
  }

  applyOrgDataUpdate(): void {
    if (!this.orgDataUpdatePreview || this.orgDataUpdatePreview.status !== 'preview') {
      return;
    }
    const confirmed = window.confirm(this.translate.instant('adminActions.orgDataUpdateApplyConfirm', {
      updated: this.orgDataUpdatePreview.summary.totalUpdatedUsers,
      deactivated: this.orgDataUpdatePreview.summary.totalDeactivatedUsers
    }));
    if (!confirmed) {
      return;
    }

    this.clearOrgDataUpdateMessages();
    this.isWaitingForOrgDataUpdate = true;
    this.userDataService.adminApplyOrgDataUpdate(
      this.getLastOrgDataUpdateReport_orgId,
      this.orgDataUpdatePreview.runId
    ).subscribe({
      next: report => {
        this.orgDataUpdatePreview = report;
        this.orgDataUpdateSelectedRun = report;
        this.orgDataUpdateSuccessMessage = this.translate.instant('adminActions.orgDataUpdateApplied', {
          passed: report.summary.verificationPassed,
          failed: report.summary.verificationFailed
        });
        this.isWaitingForOrgDataUpdate = false;
        this.loadOrgDataUpdateRuns();
      },
      error: (error: HttpErrorResponse) => this.handleOrgDataUpdateError(error)
    });
  }

  loadOrgDataUpdateRuns(): void {
    if (!this.getLastOrgDataUpdateReport_orgId) {
      return;
    }
    this.userDataService.adminGetOrgDataUpdateRuns(this.getLastOrgDataUpdateReport_orgId).subscribe({
      next: runs => {
        this.orgDataUpdateRuns = runs;
        if (runs.length > 0 && !this.orgDataUpdateCompareToRunId) {
          this.orgDataUpdateCompareToRunId = runs[0].runId;
        }
        if (runs.length > 1 && !this.orgDataUpdateCompareFromRunId) {
          this.orgDataUpdateCompareFromRunId = runs[1].runId;
        }
      },
      error: (error: HttpErrorResponse) => this.handleOrgDataUpdateError(error)
    });
  }

  viewOrgDataUpdateRun(runId: string): void {
    this.clearOrgDataUpdateMessages();
    this.userDataService.adminGetOrgDataUpdateRun(this.getLastOrgDataUpdateReport_orgId, runId).subscribe({
      next: run => this.orgDataUpdateSelectedRun = run,
      error: (error: HttpErrorResponse) => this.handleOrgDataUpdateError(error)
    });
  }

  compareOrgDataUpdateRuns(): void {
    if (!this.orgDataUpdateCompareFromRunId || !this.orgDataUpdateCompareToRunId) {
      return;
    }
    this.clearOrgDataUpdateMessages();
    this.userDataService.adminCompareOrgDataUpdateRuns(
      this.getLastOrgDataUpdateReport_orgId,
      this.orgDataUpdateCompareFromRunId,
      this.orgDataUpdateCompareToRunId
    ).subscribe({
      next: comparison => this.orgDataUpdateComparison = comparison,
      error: (error: HttpErrorResponse) => this.handleOrgDataUpdateError(error)
    });
  }

  downloadOrgDataUpdateRun(run: OrgDataUpdateRun): void {
    this.downloadTextFile(`org_data_update_${run.orgId}_${run.runId}.json`, JSON.stringify(run, null, 2));
  }

  private clearOrgDataUpdateMessages(): void {
    this.orgDataUpdateErrorMessage = "";
    this.orgDataUpdateSuccessMessage = "";
  }

  private handleOrgDataUpdateError(error: HttpErrorResponse): void {
    const detail = error?.error?.detail || error?.error?.data || error?.message;
    this.orgDataUpdateErrorMessage = detail || this.translate.instant('adminActions.orgDataUpdateError');
    this.isWaitingForOrgDataUpdate = false;
  }

  userManagement_resetPassword(): void {
    if (!this.resetPassword_userMail || !this.resetPassword_newPassword) {
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.resetPassword_userMail)) {
      this.resetPassword_errorMessage = this.translate.instant('adminActions.userAdminResetPasswordErrInvalidEmail');
      return;
    }

    const confirmed = window.confirm(
      this.translate.instant('adminActions.userAdminResetPasswordConfirm', { email: this.resetPassword_userMail })
    );
    if (!confirmed) {
      return;
    }

    this.resetPassword_successMessage = "";
    this.resetPassword_errorMessage = "";
    this.isWaitingForPasswordReset = true;

    this.userDataService.adminForcePassword(this.resetPassword_userMail, this.resetPassword_newPassword).subscribe({
      next: () => {
        this.resetPassword_successMessage = this.translate.instant('adminActions.userAdminResetPasswordSuccess', { email: this.resetPassword_userMail });
        this.resetPassword_newPassword = "";
        this.resetPassword_showPassword = false;
        this.isWaitingForPasswordReset = false;
      },
      error: (error: HttpErrorResponse) => {
        let errorBody = error?.error;
        if (typeof errorBody === 'string') {
          try { errorBody = JSON.parse(errorBody); } catch (_) {}
        }
        const detail = errorBody?.data || error?.message || "";
        if (detail === "user not found") {
          this.resetPassword_errorMessage = this.translate.instant('adminActions.userAdminResetPasswordErrUserNotFound', { email: this.resetPassword_userMail });
        } else if (detail === "wrong password policy") {
          this.resetPassword_errorMessage = this.translate.instant('adminActions.userAdminResetPasswordErrPasswordPolicy');
        } else if (detail === "wrong API token") {
          this.resetPassword_errorMessage = this.translate.instant('adminActions.userAdminResetPasswordErrApiToken');
        } else {
          this.resetPassword_errorMessage = this.translate.instant('adminActions.userAdminResetPasswordErrGeneral');
        }
        this.isWaitingForPasswordReset = false;
      }
    });
  }

  downloadTextFile(filename: string, content: string) {
    // 1) Create a Blob from the text
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    // 2) Create a temporary URL for that blob
    const url = window.URL.createObjectURL(blob);
    // 3) Create an <a> tag with the download attribute
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;        // e.g. "report.txt"
    document.body.appendChild(a);
    // 4) Programmatically click it
    a.click();
    // 5) Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
